module.exports = __webpack_public_path__ + "img/ciao.a083acd8.png";